// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/(tabs)/index.tsx"); } },
  "./(tabs)/mas.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/(tabs)/mas.tsx"); } },
  "./(tabs)/productos.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/(tabs)/productos.tsx"); } },
  "./(tabs)/reportes.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/(tabs)/reportes.tsx"); } },
  "./(tabs)/rutinas.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/(tabs)/rutinas.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/_layout.tsx"); } },
  "./checklist.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/checklist.tsx"); } },
  "./devices.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/devices.tsx"); } },
  "./garden-setup.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/garden-setup.tsx"); } },
  "./help.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/help.tsx"); } },
  "./house-edit.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/house-edit.tsx"); } },
  "./move-day.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/move-day.tsx"); } },
  "./product-edit.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/product-edit.tsx"); } },
  "./report-print.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/report-print.tsx"); } },
  "./report/[date].tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/report/[date].tsx"); } },
  "./room-edit.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/room-edit.tsx"); } },
  "./room/[id].tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/room/[id].tsx"); } },
  "./setup.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/setup.tsx"); } },
  "./sign-in.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/sign-in.tsx"); } },
  "./task/[id].tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/task/[id].tsx"); } },
  "./welcome-name.tsx": { enumerable: true, get() { return require("/app/apps/owner/src/app/welcome-name.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;